import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Divider, Form, Row, Space } from "antd";

import { saveRelaySwitch } from "../../../api/redux/action/RelaySwitchActions";
import useNotification from "../../../components/common/ResultNotifier";
import AddRelaySwitchForm from "./AddRelaySwitchForm";
import { useHistory } from "react-router-dom";
import UnsavedChanges from "../../../components/CustomHooks/UnsavedChanges";
import { ElementIDS } from "../../../components/common/ElementsIDs";
import { hasPermission } from "../../layout/Constants";
import AddFooterSection from "../../../components/common/AddFooterSection";
import { validateInput } from "../../../components/RequiredFieldRule";

const AddRelaySwitch = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [prompt, setDirty, setPristine] = UnsavedChanges();

  let history = useHistory();

  const { error, requestStatus, language, user, englishLang, selectedTenant } =
    useSelector((store) => ({
      error: store.relaySwitchReducer.error,
      requestStatus: store.relaySwitchReducer.requestStatus,
      language: store.langReducer.language,
      user: store.authReducer.user,
      englishLang: store.langReducer.englishLang,
      selectedTenant: store.authReducer.selectedTenant,
    }));
  let langSavedItem =
    language?.SAVED_ITEM?.value ?? englishLang?.SAVED_ITEM?.value;
  const [ResultNotifier, isLoading] = useNotification(
    error,
    requestStatus,
    langSavedItem
  );

  useEffect(() => {
    if (props.location.state && props.location.state.selectedRow) {
      form.setFieldsValue({
        relaySwitchId: props.location.state.selectedRow.relaySwitchId,
        name: props.location.state.selectedRow.name,
        switchNumber: props.location.state.selectedRow.switchNo,
        ipRelayCard: props.location.state.selectedRow.ipRelayCard.ipRelayCardId,
        pulseMs: props.location.state.selectedRow.pulseMs,
      });
    }
  }, []);

  useEffect(() => {
    if (requestStatus === "SUCCESS") {
      return history.push("/relaySwitches");
    }
  }, [requestStatus]);

  const handleSave = (values) => {
    const formData = {
      name: validateInput(form.getFieldValue().name),
      switchNo: validateInput(form.getFieldValue().switchNumber),
      ipRelayCardId: form.getFieldValue().ipRelayCard,
      pulseMs: validateInput(form.getFieldValue().pulseMs),
    };
    setPristine();
    dispatch(saveRelaySwitch(formData, form.getFieldValue().relaySwitchId));
  };

  const handleCancel = () => {
    history.push("/relaySwitches");
  };

  function handleEditingPermission() {
    return hasPermission(selectedTenant, "UPDATE_RELAY_SWITCHES");
  }

  const footer = (
    <AddFooterSection
      language={language}
      viewOption={props.location.state}
      handleCancel={handleCancel}
      form={form}
      updatePath={"/update-relaySwitch"}
      handleEditingPermission={handleEditingPermission}
    />
  );

  return (
    <Card
      title={language?.RELAY_SWITCH?.value ?? englishLang?.RELAY_SWITCH?.value}
      loading={isLoading}
    >
      <Row justify="center">
        <Col xs={24} sm={24} md={24} lg={24} xl={16}>
          <AddRelaySwitchForm
            handleSave={handleSave}
            form={form}
            footer={footer}
            setDirty={setDirty}
            readOnly={props.location.state}
            language={language}
          />
        </Col>
      </Row>
      <ResultNotifier />
      {prompt}
    </Card>
  );
};

export default AddRelaySwitch;
